import apiForluz, { cardeal } from './api';

export class AlteracaoPerfilService {
  getListaPerfilParticipante = async (matricula, plano) => {
    const response = await cardeal.get('ObterListaPerfilParticipante', {
      params: {
        matricula,
        plano,
      },
    });

    return response.data.ObterListaPerfilParticipanteResult.KeyValue;
  };

  getPerfilAtualParticipante = async (matricula, plano) => {
    const response = await cardeal.get('ObterPerfilAtualParticipante', {
      params: {
        matricula,
        plano,
      },
    });

    return response.data.ObterPerfilAtualParticipanteResult;
  };

  getVerificarDisponibilidadeAlterarPerfil = async (matricula) => {
    const response = await apiForluz.get(
      'VerificarDisponibilidadeAlterarPerfil',
      {
        params: {
          matricula,
        },
      }
    );

    const travasAlteracaoPerfil = {
      travaQuestionario: response.data.travaQuestionario === 1,
      travaQuestinarioExpirado: response.data.travaQuestinarioExpirado === 1,
      travaPeriodo: response.data.travaPeriodo === 1,
    };

    return travasAlteracaoPerfil;
  };

  getResultadoQuestionario = async (matricula, token) => {
    const response = await apiForluz.get('ObterResultadoQuestionario', {
      params: {
        matricula,
        token,
      },
    });

    return response.data[0];
  };

  setPerfilParticipante = async (values) => {
    const response = await cardeal.post('RegistrarMudancaPerfilParticipante', {
      matricula: values.matricula,
      codigoPerfilVigente: values.codigoPerfilVigente,
      codigoPerfilDesejado: values.codigoPerfilDesejado,
    });

    return response.data.SalvarMudancaPerfilParticipanteResult;
  };

  getHistoricoIntencaoTrocaPerfilParticipante = async (matricula) => {
    const response = await cardeal.get(
      'ObterHistoricoIntencaoTrocaPerfilParticipante',
      {
        params: {
          matricula,
        },
      }
    );

    return response.data;
  };

  getHistoricoMudancaPerfilParticipante = async (matricula) => {
    const response = await cardeal.get(
      'ObterHistoricoMudancaPerfilParticipante',
      {
        params: {
          matricula,
        },
      }
    );

    return response.data;
  };
}
